import { classNames } from "../App";

export default function CustomSeparator({ className }) {
    return (
        <div className={classNames("relative", className)}>
            <div aria-hidden="true" className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-neutral-border" />
            </div>
        </div>
    )
}